import { useTranslation } from 'react-i18next';
import { IconLocation, ImageLocation } from 'src/utils/URLUtils';
import styles from './DiscoverFirstVisit.module.scss';

interface DiscoverFirstVisitProps {
    isPlaying: boolean;
    handleSpeakerClick: () => void;
}

export default function DiscoverFirstVisit({ isPlaying, handleSpeakerClick }: DiscoverFirstVisitProps) {
    const { t } = useTranslation();

    return (
        <>
            <div className={`${styles.discoverFirstVisit} guideModal`}>
                <img
                    src={IconLocation(isPlaying ? 'speaker' : 'speaker-silent')}
                    alt="speaker"
                    className='speakerIcon'
                    onClick={handleSpeakerClick}
                />
                <img src={ImageLocation('Lexi/smile.png')} alt="lexi" className='lexiIcon' />
                <p className={styles.guideText}>{t('Decide if you know a word or should learn')}</p>
            </div>
            <div className={styles.buttonSection}>
                <button>{t('Should learn')}</button>
                <button className='turquoiseButton'>{t('Already knew')}</button>
            </div>
        </>
    );
} 